exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact[data-v-2ee5333a]{min-height:50vh;padding-top:calc(var(--LINE-HEIGHT) * 3);padding-bottom:0}@media only screen and (max-width:576px){.contact[data-v-2ee5333a]{min-height:calc(50vh + var(--LINE-HEIGHT) * 5)}}.contact-grid[data-v-2ee5333a]{align-items:center;min-height:50vh}@media only screen and (max-width:576px){.contact-grid[data-v-2ee5333a]{min-height:50vh}}.avatar[data-v-2ee5333a]{border-radius:100%;height:calc(var(--LINE-HEIGHT) * 5);margin-bottom:calc(var(--LINE-HEIGHT) * 1);background-color:#f08080;vertical-align:bottom;border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ee5333a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Section.Contact.vue
// module id = 97
// module chunks = 0